import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { fullName, email, message } = formData;

    const text = `Alert from TTD Website\nName: ${fullName}\nEmail: ${email}\nMessage: ${message}`;
    const encodedText = encodeURIComponent(text);

    // WhatsApp chat link
    const whatsappUrl = `https://wa.me/918121877077?text=${encodedText}`;

    // Open WhatsApp
    window.open(whatsappUrl, "_blank");
  };

  return (
    <div className="container py-5">
      <h2 className="text-center mb-5 text-primary fw-bold">Contact Us</h2>
      <div className="row justify-content-center">
        <div className="col-md-10 d-flex flex-column flex-md-row">
          {/* Left: Contact Form */}
          <div className="col-md-6 pe-md-5">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Full Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Your name"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Email address</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Your email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Message</label>
                <textarea
                  className="form-control"
                  rows="5"
                  placeholder="Your message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary mt-2">
                Send via WhatsApp
              </button>
            </form>
          </div>

          {/* Vertical divider */}
          <div className="d-none d-md-block border-end border-2 mx-4"></div>

          {/* Right: Office Info */}
          <div className="col-md-6 ps-md-4 mt-4 mt-md-0">
            <h5 className="fw-bold mb-3">Our Office</h5>
            <p>🏢 Zenovus Technologies LLC</p>
            <p>📍 2nd Floor, Daimond Plaza, Financial Distict, Gachibowli</p>
            <p>📞 +91 81218 77077</p>
            <p>✉️ contact@zenovus.com</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
